import { render, staticRenderFns } from "./ServerTR.vue?vue&type=template&id=1e9563f4&scoped=true&"
import script from "./ServerTR.vue?vue&type=script&lang=js&"
export * from "./ServerTR.vue?vue&type=script&lang=js&"
import style0 from "./ServerTR.vue?vue&type=style&index=0&id=1e9563f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9563f4",
  null
  
)

export default component.exports